module.exports = __webpack_public_path__ + "static/img/logo20201219.2603b7a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/index/logo20201219.png
// module id = xvM3
// module chunks = 23